export enum ZpusobDolozeniOpravneni {
	DATOVA_ZPRAVA = 'DATOVA_ZPRAVA',
	EMAIL = 'EMAIL',
	PRILOZIT_DOKUMENTY_ZDE = 'PRILOZIT_DOKUMENTY_ZDE',
	NIC = 'NIC'
}
